import { fromJS } from 'immutable';
import { CONFIRM } from './constants';

export const confirm = (symbol) => ({
  type: CONFIRM,
  payload: fromJS({ symbol }),
});